import { Stack } from "react-bootstrap";
import { Term } from "../../utils/interfaces";

import PileSorter from "../PileSorter/PileSorter";

type PileData = {
  label: string;
  name: string;
  items: Term[];
}

type Step1Props = {
  label: string;
  moveCard: (item: Term, category: string) => void;
  pileData: Array<PileData>;
  resetPile: () => void;
  undoMoveCard: () => void;
  unsorted: Array<Term>;
};

const Step1: React.FC<Step1Props> = ({
  label,
  moveCard,
  pileData,
  resetPile,
  undoMoveCard,
  unsorted,
}) => {
  const handleSort = (item: Term, category: string) => {
    moveCard(item, category)
  }

  return (
    <Stack gap={3}>
      <h3 className="text-xl font-semibold mb-4">
        Step 1: Select the category that best describes how each term applies to you
      </h3>

      <PileSorter
        label={label}
        onSort={handleSort}
        resetPile={resetPile}
        sorted={pileData}
        undoMoveCard={undoMoveCard}
        unsorted={unsorted}
      />
    </Stack>
  );
};

export default Step1;
